export const normalizeVehicleNumber = value => typeof value === 'string' ? value.replace(/[^\p{L}\p{N}]/gu, '') : value

export function normalizeVehiclePayload(payload) {
  if (payload instanceof FormData) {
    if (payload.has('vehicle_number')) payload.set('vehicle_number', normalizeVehicleNumber(payload.get('vehicle_number')))
    return payload
  }
  return payload && Object.prototype.hasOwnProperty.call(payload, 'vehicle_number')
    ? { ...payload, vehicle_number: normalizeVehicleNumber(payload.vehicle_number) }
    : payload
}
